module.exports = __webpack_public_path__ + "static/img/图像 18@2x.1115532.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/erpManage/img/图像 18@2x.png
// module id = Rn2i
// module chunks = 10